import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import CallIcon from "@mui/icons-material/Call";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";

const CheckinCustomerBasicDetail = ({ data }) => {
  const classes = useStyles();
  let history = useHistory();

  return (
    <>
      <Box className={classes.grandParent}>
        <Box className={classes.arrowContainer}>
          <ArrowBackIcon
          className={classes.arrowBackIcon}
            onClick={() => history.goBack()}
          />
        </Box>
        <Box>
          <Box
            className={classes.headingBox}
          >
            <Text
              variant="h4"
              component="div"
              gutterBottom
              className={classes.heading_name}
          
            >
              {data?.fullName}
            </Text>
            <p className={classes.personalText} >
              PERSONAL DETAILS
            </p>
          </Box>
          <Box className={classes.detailParentBox}>
            <Box className={classes.image}>
              <img
                src={data?.profilePicture}
                alt="profilePic"
               
              />
            </Box>

            <Box className={classes.childBox}>
              <Box className={classes.subChildBox}>
                <Box>
                  <Text
                    className={classes.textheadName}
                    variant="h"
                    component="div"
                    gutterBottom
                 >
                    {data?.fullName}
                  </Text>
                </Box>
              </Box>
              {/* <Box>
                <Text
                  className={classes.texthead}
                  variant="a"
                  component="div"
                  gutterBottom
                  sx={{
                    letterSpacing: "0.28px",
                    color: "#707070",
                    opacity: "1",
                    textAlign: "left",
                    marginTop: "5px",
                    marginLeft: "7px",
                  }}
                >
                  #01234567
                </Text>
              </Box> */}

              <Box>
                <Box className={classes.mobileConatiner} >
                  <CallIcon sx={iconStyle} />
                  <Text
                    className={classes.textheadmobile}
                    variant="a"
                    component="div"
                    gutterBottom
                  
                  >
                    {data?.mobile}
                  </Text>
                </Box>
                <Box sx={{ display: "flex" }}>
                  <MailOutlineIcon sx={iconStyle}></MailOutlineIcon>
                  <Text
                    className={classes.textheadmobile}
                    variant="a"
                    component="div"
                    gutterBottom
                  
                  >
                    {data?.email}
                  </Text>
                </Box>
              </Box>
            </Box>

            <Box className={classes.loginDetailParent}>
              <Box  className={classes.detailParentBoxDate}>
                <Text className={classes.loginDetailDesc}>Date : Time :</Text>
                <Text className={classes.loginDetail}>{data?.lastLogin}</Text>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  grandParent: {
    padding: "1rem 0rem",
    "@media (max-width:768px)": {
      padding: "0px",
    },
  },
  webUrl: {
    letterSpacing: "0.28px",
    color: "#707070",
    opacity: "1",
    textAlign: "left",
    textDecoration: "underline",
    marginTop: "5px",
  },
  detailParentBox: {
    display: "flex",
    margin: "10px 20px",
    alignItems: "center",
    "@media (max-width:768px)": {
      flexDirection: "column",
    },
  },
  childBox: {
    margin: "0px 1rem",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "@media (max-width:768px)": {
      marginLeft: "-51px",
    },
  },
  subChildBox: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    "@media (max-width:768px)": {
      display: "block",
      marginLeft: "5px",
    },
  },

  headingBox: {
    marginTop: "-30px",
    marginLeft: "30px",
    color: "#707070",

    "@media (max-width:768px)": {
      marginLeft: "16px",
    },
  },
  image: {
    "@media (max-width:768px)": {
      marginLeft: "-46px",
    },
  },
  texthead: {
    "@media (max-width:768px)": {
      marginLeft: "10px",
    },
  },

  loginDetail: {
    fontSize: "14px",
    color: "#000000",
  },
  loginDetailDesc: {
    fontSize: "12px",
    color: "#474747",
  },
  loginDetailParent: {
    width: "150px",
  },
  arrowContainer:{
    display:'flex'
  },
  arrowBackIcon:{
    fontSize: "20px",
    margin: "0px 0px 10px 0px",
    color: "#707070",
  },
  heading_name:{
    color: "#1A1A1A",
     marginLeft: "14px" 
  },
  personalText:{
    color: "#545454", 
    marginLeft: "14px"
  },
  profilePicture:{
    width:"150px",
    height:"150px",
    borderRadius: "100px",
     marginLeft: "18px"
  },
  textheadName:{
      color: "#707070",
      marginTop: "5px",
      fontSize: "16px",
      fontWeight: "bold",
      marginLeft: "5px"
  },
  mobileConatiner:{
    display: "flex" 
  },
  textheadmobile:{
    letterSpacing: "0.28px",
    color: "#707070",
    opacity: "1",
    textAlign: "left",
    marginTop: "5px",
  },
  detailParentBoxDate:{
    display:"flex",
    alignItems:'center'
  }
}));

export default CheckinCustomerBasicDetail;

const iconStyle = { margin: "7px 5px 0px 5px", width: "20px", height: "20px" };
